export const mail = () => (
  <path
    d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6m20 0l-10 7L2 6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
